import React from 'react'
import CollaborateSection from '../Components/hospital/CollaborateSection'
import ProductOverview from '../Components/hrms/ProductOverview'
import OurIndustriesSection from '../Components/hrms/OurIndustriesSection'
import WhyGlodesk from '../Components/hrms/WhyGlodesk'
import { Helmet } from "react-helmet-async";
function Hrms() {
    return (
        <div>
            <Helmet>
    <title>
        HRMS Corporate | Workforce Management & HR Solutions | Mobikode
    </title>

    <meta
        name="description"
        content="Discover Mobikode's HRMS Corporate solution for managing the complete employee lifecycle from recruitment to retirement through a unified, efficient, and scalable workforce management platform."
    />

    <meta
        name="keywords"
        content="HRMS Corporate, HRMS Software, HR Management System, Human Resource Management System, Workforce Management Software, Employee Management Software, HRMS Solutions, HR Software Solutions, Employee Lifecycle Management, Recruitment Management Software, Payroll Management, HR Automation, Enterprise HRMS, Digital HR Solutions, Workforce Technology, HR Technology Solutions"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/hrms"
    />

    <meta
        property="og:title"
        content="HRMS Corporate | Workforce Management & HR Solutions | Mobikode"
    />

    <meta
        property="og:description"
        content="Manage your workforce from recruitment to retirement with Mobikode's unified HRMS Corporate solution designed to simplify HR operations and improve workforce management."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/hrms"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/hrms/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="HRMS Corporate | Workforce Management & HR Solutions | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Simplify employee lifecycle management with Mobikode's HRMS Corporate platform, covering workforce management from recruitment through retirement."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/hrms/bg1.png"
    />
</Helmet>
            <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/hrms/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            HRMS Corporate
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Manage your entire workforce from recruitment to retirement
                            with one unified platform.

                        </p>
                    </div>
                </div>
            </section>
            <ProductOverview />
            <OurIndustriesSection />
            <WhyGlodesk />
            <CollaborateSection />
        </div>
    )
}

export default Hrms
